import { render, staticRenderFns } from "./Smart.vue?vue&type=template&id=c4a64304&scoped=true&"
import script from "./Smart.vue?vue&type=script&lang=js&"
export * from "./Smart.vue?vue&type=script&lang=js&"
import style0 from "./Smart.vue?vue&type=style&index=0&id=c4a64304&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4a64304",
  null
  
)

export default component.exports